export default {
    namespaced: true,
    pbx_device: {
      title: "Dispositivo | Dispositivos",
      name: "nombre",
      extension: "extensión",
      password: "contraseña",
      ha1: "HA1",
      dispatch_alarm: "Genera alarma",
      ivr: "IVR",
    },
  };
